import { Component, OnInit,ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http'; 
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-device-log',
  templateUrl: './device-log.component.html',
  styleUrls: ['./device-log.component.scss']
})
export class DeviceLogComponent implements OnInit {

   @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
	dtOptions: any = {};
	// dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private request : RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe:DatePipe
  ) { }

  ngOnInit() {
    this.ViewDeviceLog();
  }

  rowData;
  toiletLogDetails=[];
  async ViewDeviceLog(){
    try {
      // alert("here");
      const logs = {};
      this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/master/view_device_log',logs);
      this.toiletLogDetails=[];
      this.dtTrigger.next();
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            dataObj[objKey1].date_time = this.normalizeTimestamp(Number(dataObj[objKey1].date_time));
            dataObj[objKey1].received_time = this.normalizeTimestamp(Number(dataObj[objKey1].received_time));
            this.toiletLogDetails.push(dataObj[objKey1]);
          } 
        }				
      }
      this.rowData = this.toiletLogDetails;
    } catch (error) {}
  }

  normalizeTimestamp(timestamp: number): number {
    const length = timestamp.toString().length;

    if (length === 10) {
      // Convert seconds → milliseconds
      return timestamp * 1000;
    } else if (length === 13) {
      // Already in milliseconds
      return timestamp;
    } else {
      throw new Error("Invalid timestamp format");
    }
  }

}
